import {debounceTime} from 'rxjs/operators';
import {Component, OnInit, Output, EventEmitter, OnChanges, Input} from '@angular/core';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  TypesService,
  ProductService,
  RateService,
  CollateralService,
  PricingOutput,
  SalesService
} from '../../../services';
import {Decimal} from 'decimal.js';
import _ from 'lodash';
import * as moment from 'moment';
import {DataHandlerService} from '../../../services/data-handler.service';
import {Observable} from 'rxjs';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {ValidationPartialComponent} from '../partials/validation-partial.component';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {NgIf, NgFor} from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import {
  CarSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/car-search/car-search.component';
import {LCA_ORIGINATOR_PARTY_ROLE_ID} from '../../../_global/wiz.constants';

@Component({
  selector: 'app-loan-details-terms',
  templateUrl: './loan-details-terms.component.html',
  styles: [],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MatCardModule, MatCardModule, NgIf, MatFormFieldModule,
    MatFormFieldModule, MatInputModule, MatInputModule, ValidationPartialComponent, NgFor, MatSelectModule,
    MatSelectModule, MatOptionModule, MatOptionModule, MatCheckboxModule, MatCheckboxModule, MatButtonModule,
    MatButtonModule, MatTooltipModule, MatIconModule, MatProgressSpinnerModule, CarSearchComponent]
})

export class LoanDetailsTermsComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public brokerDetails: any;
  @Input() public originatorDetails: any;
  @Input() public loanPurposeType: any;
  @Input() public isPersonalLoan = true;
  @Input() public currentPurchaseAmount: any;
  @Input() public featureSwitches: any;
  @Input() public storageIdentifier: any;
  @Input() public isGreen = false;
  @Input() public isRetail = false;
  @Input() public caravanDisabled = false;
  @Input() public isInternalUser = false;
  @Output() public loanInsuranceList = new EventEmitter<any[]>();
  @Output() public selectedVehicle = new EventEmitter<any[]>();
  @Output() public emitInterestType = new EventEmitter<string>();
  @Output() public emitGreen = new EventEmitter<boolean>();
  @Output() public loanPurpose = new EventEmitter<boolean>();
  @Output() public loanProduct = new EventEmitter<boolean>();

  public productTypes: any;
  public productVariations = [];
  public loanPurposes = [];
  public insurancePurposes = [];
  public loanTerms = [];
  public repaymentTypes = [];
  public allBalloons = [];
  public variantTypes = [];
  public repaymentTypesSlug = 'frequencies-vx';
  public enableProductList = false;
  public enableLoanTerms = false;
  public enableBalloons = false;
  public interestType: string;
  public rateData: PricingOutput;
  public totalLoanAmount: any;

  public vehicleAge: number = null;
  public loanTermInYears: number = null;
  public realEstateCountWithoutNas = 0;
  private _broker: any;
  private _collateral: any;
  private _loanPurpose: any;
  private _securityType = 'new';
  private _selectedLoanTerm: any;
  private _purchaseAmount = 0;
  private _productType = 'motor-vehicle';
  private _loanPurposesTypeSlug = 'vx-purposes';
  private _loanPurposeGroupSlugs = ['purchase', 'refinance'];
  private _insurancePurposeGroupSlugs = ['ancillary'];
  public motorVehicleClasses: any = [];
  public isLoadingVariants = false;

  public types: any = ['feature-switches', 'motor-vehicle-classes'];


  constructor(private typesService: TypesService,
              private rateService: RateService,
              public dataHandlerService: DataHandlerService,
              private collateralService: CollateralService,
              private productService: ProductService,
              private salesService: SalesService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.getTypes().subscribe((result: any) => {
    });

    this.populatePurposes();
    this.populateRepaymentTypes();
    this.initSubscriptions();
    this.initVariantSpecs();

    // patch vehicle usage from opts
    if (this.opts && this.opts.vehicleUsage) {
      this.formGroup.patchValue({usage: this.opts.vehicleUsage});
    }

    this.checkTotalMonthlyRepayments();

    this.dataHandlerService.getAutoLoanAmountData().subscribe((data) => {
      this.totalLoanAmount = data;
    });

    this.dataHandlerService.getRealEstateCountWithoutNas().subscribe((data) => {
      this.realEstateCountWithoutNas = data;
      this.formGroup.get('homeOwnerDiscount').disable({emitEvent: false});
      this.formGroup.get('homeOwnerDiscount').patchValue((data > 0), {emitEvent: false});

      console.log('getRealEstateCountWithoutNas', data);
      console.log('homeOwnerDiscount', this.formGroup.get('homeOwnerDiscount').getRawValue());
    });

    this.dataHandlerService.getIsRetailFlag().subscribe((data) => {
      this.isRetail = data;
      this.populatePurposes();
    });
  }

  ngOnChanges(changes) {
    if (changes['originatorDetails'] && this.originatorDetails && this.originatorDetails.id !== LCA_ORIGINATOR_PARTY_ROLE_ID && this.caravanDisabled) {
      // check if not LCA and set vehicleType
      this.formGroup.get('vehicleType').patchValue('car');
    }

    if (changes['brokerDetails']) {
      this._broker = changes['brokerDetails']['currentValue'];
      this.getVxProducts();
    }

    if (changes['currentPurchaseAmount']) {
      this._purchaseAmount = changes['currentPurchaseAmount']['currentValue'];
      this.calculateBalloon();
    }

    // handle refresh
    if (changes['formGroup'] && changes['formGroup']['firstChange']) {
      // purpose
      if (changes['formGroup']['currentValue']['value']['purpose']) {
        this._loanPurpose = changes['formGroup']['currentValue']['value']['purpose'];
      }
      // loan term
      if (changes['formGroup']['currentValue']['value']['loanTermId']) {
        this._selectedLoanTerm = changes['formGroup']['currentValue']['value']['loanTermId'];
      }
      this.getVxProducts();

      if (changes['isRetail']) {
        this.populatePurposes();
      }
    }

    setTimeout(() => {
      this.formGroup.get('monthlyRepayment').disable();
      this.formGroup.get('monthlyFee').disable();
      this.formGroup.get('totalMonthlyRepayment').disable();
    }, 5000);
  }

  updateVehicleType(value) {
    this.dataHandlerService.sendVehicleType(value);
    this.formGroup.get('vehicle').reset();
    this.formGroup.get('vin').reset();
    this.formGroup.get('nvic').reset();
    this.variantTypes = [];
    this.getVxProducts();
  }

  public initSubscriptions() {
    // car search
    this.formGroup.valueChanges.pipe(
      debounceTime(500))
      .subscribe(val => {
        console.debug('LoanDetailsTermsComponent.initSubscriptions.formGroup');
        if (val && val.vehicle.id && JSON.stringify(this._collateral) !== JSON.stringify(val.vehicle)) {
          this.selectedVehicle.emit(val.vehicle);
          this.dataHandlerService.setSecuredAsset(val);
          this._collateral = val.vehicle;
          this.rateService.setRateParameters({
            year: this._collateral.year,
            make: this._collateral.make,
            model: this._collateral.model
          });

          const comparisonYear: number = +(moment().format('YYYY'));
          this.vehicleAge = Math.abs(comparisonYear - this._collateral.year);
          this.enableBalloons = (this.vehicleAge <= 5);

          this.getVxProducts();
          this.populateBalloons();
          this.retrieveVariants(val.vehicle.id);
        }

        this.dataHandlerService.sendIsHomeOwner(this.formGroup.get('homeOwnerDiscount').getRawValue());
      });

    // handle changes in loan purpose
    this.formGroup.get('vin').valueChanges.pipe(
      debounceTime(500))
      .subscribe((val: any) => {
        if (this.formGroup.get('purpose').value !== 'purchase-new-personal' && !val) {
          this.formGroup.get('odometerReading').patchValue(null);
        }
      });

    if (this.formGroup.get('purpose').value) {
      this.updatePurpose(this.formGroup.get('purpose').value);
    }

    // handle changes in loan purpose
    this.formGroup.get('purpose').valueChanges.pipe(
      debounceTime(500))
      .subscribe(
        val => {
          console.debug('LoanDetailsTermsComponent.initSubscriptions.purpose');
          // console.log('[purpose]', val);
          if (val === 'purchase-new-personal') {
            this.formGroup.get('odometerReading').patchValue(null);
          }

          this._loanPurpose = val;
          this.rateService.setRateParameters({primaryPurpose: val});
          this.setSecurityType(val);
          this.getVxProducts();
          this.populateBalloons();
          this.updatePurpose(val);
        }
      );

    this.formGroup.get('balloonAmount').valueChanges.pipe(
      debounceTime(500))
      .subscribe(
        val => {
          // if balloon amount has changed manually
          if (this._purchaseAmount) {
            const value = +(Number(val) / Number(this._purchaseAmount || 0) * 100).toFixed(2);
            // get the maximum balloon % first
            const max = this.allBalloons[this.allBalloons.length - 1];

            if (Number(value) > max) {
              this.formGroup.get('balloonPercentage').patchValue(max, {emitEvent: false});
              this.calculateBalloon();
              return;
            }

            if (this.allBalloons.indexOf(value) === -1 && value && value > -1) {
              this.allBalloons.push(value);
              this.allBalloons = this.allBalloons.sort((a, b) => a - b);
            }
            this.formGroup.get('balloonPercentage').patchValue(value, {emitEvent: false});
          }
          this.rateService.setRateParameters({balloonAmount: Number(val)});
        }
      );

    // handle changes in loan product type
    this.formGroup.get('product').valueChanges.pipe(
      debounceTime(500))
      .subscribe(
        val => {
          this.populateLoanTerms(this.productVariations.find(x => x.slug === val));
        }
      );

    if (this.formGroup.value.vehicle && this.formGroup.value.vehicle.id) {
      this.retrieveVariants(this.formGroup.value.vehicle.id);
    }

    this.rateService.rateData.subscribe((val) => {
      this.rateData = val;

      if (val) {
        if (val.IsGreen.toLowerCase() === 'true') {
          this.isGreen = true;
        } else {
          this.isGreen = false;
        }

        this.emitGreen.emit(this.isGreen);

        // handle max Interest rate
        if (val.FirstmacMaxBorrowingRate && !isNaN(val.FirstmacMaxBorrowingRate) &&
          val.TPSRateToBorrower && !isNaN(val.TPSRateToBorrower)) {
          // only set the validator if max borrowing rate > 0
          if (val.FirstmacMaxBorrowingRate && Number(val.FirstmacMaxBorrowingRate)) {
            const max = new Decimal(val.FirstmacMaxBorrowingRate).mul(100);
            const min = max.sub(2);
            this.rateData.minInterestRateInput = min.toNumber();
            this.rateData.maxInterestRateInput = max.toNumber();
            this.formGroup.get('interestRate').setValidators([Validators.min(min.toNumber()), Validators.max(max.toNumber())]);
          }
          const interestRate = new Decimal(this.rateData.TPSRateToBorrower).mul(100).toNumber();
          this.formGroup.get('interestRate').updateValueAndValidity({emitEvent: false});
          this.formGroup.get('interestRate').patchValue(interestRate, {emitEvent: false});
        } else {
          this.formGroup.get('interestRate').clearValidators();
          this.formGroup.get('interestRate').updateValueAndValidity({emitEvent: false});
        }
      }
    });
  }

  public setSecurityType(purpose) {
    switch (purpose) {
      case 'purchase-new-business':
      case 'purchase-new-personal':
        this._securityType = 'new';
        break;

      case 'purchase-used-business':
      case 'purchase-used-personal':
        this._securityType = 'used-dealer';
        break;

      case 'refinance-personal':
      case 'purchase-used-private':
        this._securityType = 'used-private';
        break;

      default:
        this._securityType = 'used-dealer';
    }
    this.loanPurpose.emit(purpose);
    this.formGroup.get('securityType').patchValue(this._securityType, {emitEvent: false});
  }

  public populateRepaymentTypes() {
    this.repaymentTypes.push({
      id: 'monthly',
      text: 'Monthly',
    });
    this.formGroup.get('repaymentFrequency').patchValue('monthly', {emitEvent: false});
  }

  public populatePurposes() {
    this.typesService.getTypesList(this._loanPurposesTypeSlug)
      .then(results => {
        this.loanPurposes = [];

        results.filter((res: any) => {
          if (this._loanPurposeGroupSlugs.includes(res.ext.loanPurposeGroup)
            && res.ext.productCategory.includes(this.loanPurposeType)
            && res.ext.personal === this.isPersonalLoan
            && res.ext.business === !this.isPersonalLoan) {

            this.loanPurposes.push(res);
          } else if (this._insurancePurposeGroupSlugs.includes(res.ext.loanPurposeGroup) && res.ext.productCategory.includes(this.loanPurposeType)) {
            this.insurancePurposes.push(res);
          }
        });

        this.loanInsuranceList.emit(this.insurancePurposes);
      });
  }

  updatePurpose(purpose: string) {
    this.dataHandlerService.getOriginatorChannel()
      .subscribe((data: any) => {
        if (data) {
          const payload: any = {
            productCategoryType: 'motor-vehicle-loan',
            purpose,
            channel: data
          };

          this.salesService.getFeeTypeConfiguration('application', payload)
            .subscribe({
              next: (fee: any) => {
                if (fee && fee.amount) {
                  this.dataHandlerService.setApplicationFee(fee);
                }
              },
              error: (err: any) => {
                console.log('error', err);
              },
              complete: () => {
                console.log('complete');
              }
            });
        }

      });
  }

  public getVxProducts() {
    if (this.brokerDetails && this._collateral && this._loanPurpose) {
      if (this.formGroup.get('purpose').value) {
        this.setSecurityType(this.formGroup.get('purpose').value);
      }

      this.productService.getMotorVehicleVariationsList(this._productType, this.brokerDetails.id, this._loanPurpose, this._securityType, this._collateral.year, this.formGroup.get('vehicleType').value)
        .subscribe(results => {
          this.productVariations = results;
          this.loanTerms = [];
          if (!this.formGroup.get('product').value && this.productVariations && this.productVariations.length > 0) {
            this.formGroup.get('product').setValue(this.productVariations[0].slug, {emitEvent: false});
            if (this.productVariations[0].pricing && this.productVariations[0].pricing.length) {
              this.formGroup.get('productPricing').setValue(this.productVariations[0].pricing[0].slug);
            }
            this.populateLoanTerms(this.productVariations[0]);
          } else if (this.formGroup.get('product').value && this.productVariations && this.productVariations.length > 0) {
            const product = this.productVariations.find(x => x.slug === this.formGroup.get('product').value);

            if (product) {
              this.formGroup.get('product').setValue(product.slug, {emitEvent: false});
              if (product.pricing && product.pricing.length) {
                this.formGroup.get('productPricing').setValue(product.pricing[0].slug);
              }
              this.populateLoanTerms(product);
            }
          }
          this.enableProductList = true;
          this.populateBalloons();
        });
    }
  }

  public populateLoanTerms(product) {
    console.log('populateLoanTerms', product);
    this.loanTerms = [];
    if (product && product.pricing) {
      this.loanProduct.emit(product);
      // get pricing allowed to use
      const pricing = product.pricing.find(x => x.allowConsumer);
      // create terms
      pricing.rates.forEach((rate) => {
        const term = {
          slug: rate.term.value + '-' + rate.term.unit,
          name: rate.term.value + ' ' + rate.term.unit,
          rate: rate
        };
        this.loanTerms.push(term);
      });
      this.updateTerm(this.formGroup.get('loanTermId').value);
      this.enableLoanTerms = true;
      if (this.formGroup.get('allowCards')) {
        this.formGroup.get('allowCards').patchValue(product.allowCards);
      }

      this.formGroup.get('monthlyFee').reset({value: pricing.monthlyFee, disabled: true}, {emitEvent: false});
      this.formGroup.get('interestType').patchValue(pricing.interestType[0]);
      this.formGroup.get('productPricing').patchValue(pricing.slug);
      this.interestType = pricing.interestType[0];
      this.emitInterestType.emit(this.interestType);
      this.rateService.setRateParameters({interestType: pricing.interestType[0]});
      this.toggleBalloonFieldState();
    } else {
      this.formGroup.get('loanTermId').reset();
    }
  }

  public toggleBalloonFieldState() {
    if (this.interestType === 'variable') {
      this.formGroup.get('balloonAmount').reset({value: 0, disabled: true}, {emitEvent: false});
      this.formGroup.get('balloonPercentage').reset({value: 0, disabled: true}, {emitEvent: false});
    } else {
      this.formGroup.get('balloonAmount').enable({emitEvent: false});
      this.formGroup.get('balloonPercentage').enable({emitEvent: false});
    }
  }

  public updateTerm(slug) {
    this._selectedLoanTerm = slug;
    if (this.loanTerms.length > 0) {
      this.formGroup.get('loanTerm').setValue(this.loanTerms.find(x => x.slug === slug), {emitEvent: false});

      if (this.formGroup.get('interestType').value === 'fixed') {
        this.formGroup.get('fixedTerm').setValue(this.loanTerms.find(x => x.slug === slug), {emitEvent: false});
      } else {
        this.formGroup.get('fixedTerm').setValue(null, {emitEvent: false});
      }

      this.interestType = this.formGroup.get('interestType').value;
      this.emitInterestType.emit(this.interestType);
      this.toggleBalloonFieldState();

      const matchingTerm = this.loanTerms.find(t => t.slug === slug);
      if (matchingTerm) {
        this.rateService.setRateParameters(
          {
            termInYears: matchingTerm.rate.term.value, // hopefully this is always in years?
            baseRate: new Decimal(matchingTerm.rate.rtb).toNumber(),
            interestType: this.formGroup.get('interestType').value
          });
      }

    }
    this.populateBalloons();
  }

  checkTotalMonthlyRepayments() {
    this.dataHandlerService.getDialDownData().subscribe((data: any) => {
      if (data && data.AdjustedTotalMonthlyRepayments) {
        this.formGroup.get('monthlyRepayment').reset({
          value: data.AdjustedTotalMonthlyRepayments,
          disabled: true
        }, {emitEvent: false});
        this.formGroup.get('totalMonthlyRepayment').reset({
          value: +(data.AdjustedTotalMonthlyRepayments) + +(this.formGroup.get('monthlyFee').value),
          disabled: true
        }, {emitEvent: false});
      }
    });
  }

  public calculateBalloon() {
    const value = +(Number(this._purchaseAmount || 0) * (Number(this.formGroup.get('balloonPercentage').value || 0) / 100)).toFixed(2);
    this.formGroup.get('balloonAmount').patchValue(value.toString());
  }


  public populateBalloons() {
    this.loanTermInYears = this._selectedLoanTerm?.split('-')[0] || 0;
    if (this._loanPurpose && this._collateral && this.vehicleAge < 5 && this.loanTermInYears < 6) {
      this.productService.getBalloons(this._productType, this._loanPurpose, this._collateral.year, this.loanTermInYears, this.formGroup.get('vehicleType').value)
        .subscribe((results) => {
          this.allBalloons = [];
          // console.log('[getBalloons]', results);
          if (results) {
            this.allBalloons = results;
            const max = results[results.length - 1] || 0;
            // if currently selected balloon is no longer allowed
            const curPercentage = this.formGroup.get('balloonPercentage').value;
            if (results.indexOf(curPercentage) === -1) {
              if (curPercentage <= max) {
                if (this.allBalloons.indexOf(curPercentage) === -1 && curPercentage && curPercentage > -1) {
                  this.allBalloons.push(curPercentage);
                  this.allBalloons = this.allBalloons.sort((a, b) => a - b);
                }
              } else {
                this.formGroup.get('balloonPercentage').setValue(0, {emitEvent: false});
                this.formGroup.get('balloonAmount').setValue(0, {emitEvent: false});
              }
            }

          } else {
            // defaults to 0
            this.allBalloons.push(0);
            this.formGroup.get('balloonPercentage').setValue(0, {emitEvent: false});
          }
        });
    } else {
      this.enableBalloons = (this.vehicleAge <= 5 && this.loanTermInYears < 6);
      this.formGroup.get('balloonAmount').reset({value: 0, disabled: true});
      this.formGroup.get('balloonPercentage').reset({value: 0, disabled: true});
    }
  }

  /**
   * Initialize the variant specs if none was populated initially
   */
  initVariantSpecs() {
    if (!this.formGroup.value.specs && this.formGroup.value.variant) {
      this.getVariantSpecs({
        value: this.formGroup.value.variant
      });
    }

    if (!this.formGroup.value.variant) {
      this.isGreen = false;
      this.emitGreen.emit(this.isGreen);
    }

    if (this.formGroup.get('vehicleType').value) {
      this.dataHandlerService.sendVehicleType(this.formGroup.get('vehicleType').value)
    }
  }

  getVariantSpecs(event: any) {
    // this.formGroup.get('className').patchValue(null);
    if (event.value && event.value !== 'null') {
      // this.formGroup.get('nvic').setErrors({'required': true});
      this.collateralService.retrieveSpecifications(event.value, this.formGroup.get('vehicleType').value)
        .subscribe((response: any) => {
          this.formGroup.get('specs').patchValue(response, {emitEvent: false});
          this.rateService.setRateParameters({
            engineName: response.engineName,
            engineCapacity: response.ccName ? _.split(response.ccName, ' ')[0] : null,
            fuelName: response.fuelName,
            variantName: response.variantName,
            transmissionType: response.transmissionName
          });
        }, (err) => {
          console.log('Error during retrieving vehicle specs', err);
          this.rateService.setRateParameters({
            engineName: null,
            engineCapacity: null,
            fuelName: null,
            variantName: null,
            transmissionType: null
          });
        });
    } else {
      this.formGroup.get('variant').patchValue(null);
      this.formGroup.get('specs').patchValue(null);
      this.rateService.setRateParameters({
        engineName: null,
        engineCapacity: null,
        fuelName: null,
        variantName: null,
        transmissionType: null
      });
    }
  }

  retrieveVariants(slug) {
    this.isLoadingVariants = true;
    this.collateralService.retrieveVariants(slug).subscribe((res: any) => {
      if (JSON.stringify(this.variantTypes) !== JSON.stringify(res)) {
        this.variantTypes = res;
      }
      this.isLoadingVariants = false;
    }, (err) => {
      console.log(err);
      this.variantTypes = [];
      this.isLoadingVariants = false;
    });
  }

  getTypes(): Observable<any> {
    return new Observable(observer => {
      this.typesService.getTypes(this.types).subscribe(
        lists => {
          lists.forEach((list, index) => {
            this[_.camelCase(this.types[index])] = list;
          });
          observer.next(null);
          observer.complete();
        },
        error => {
          console.log(error);
          observer.error(error);
        });
    });
  }

  protected readonly LCA_ORIGINATOR_PARTY_ROLE_ID = LCA_ORIGINATOR_PARTY_ROLE_ID;
}
